import { useStoreWrapper } from "../../../../store/store";
import { BigBoldText } from "../../dashboard/home/home.style";
import { TableContainer } from "../../../../components/DashboardComps/Dashboard.styles";
import StyledTable from "../../../../components/StyledTable/StyledTable";
import { useNavigate } from "react-router-dom";
import { BackBtn } from "../../Users/components/logIncident/logIncident.style";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { incidentLists } from "../dummyData/colums";
import { useIncidentList } from "../../IncidentsList/utils";

const IncidentsByTrends = () => {
  const navigate = useNavigate();

  const { incidentsFromTrends, setIncidentsFromTrends } = useStoreWrapper(
    (state) => ({
      incidentsFromTrends: state.incidentsFromTrends,
      setIncidentsFromTrends: state.setIncidentsFromTrends,
    })
  );

  const { setSelectedIncident, isLoading } = useIncidentList();

  if (incidentsFromTrends === null) {
    navigate("/user/analytics");
  }

  return (
    <div title="incidents-by-trebds">
      <div className="mb-10 mt-10">
        <BigBoldText>Incidents By Trends</BigBoldText>
      </div>
      <BackBtn
        onClick={() => {
          setIncidentsFromTrends(null);
          navigate(-1);
        }}
      >
        <ArrowLeftIcon width="30px"></ArrowLeftIcon>
        Back to incident trends
      </BackBtn>

      <TableContainer>
        <StyledTable
          tableCols={incidentLists()}
          tableData={incidentsFromTrends}
          getUserCb={(item: any) => setSelectedIncident(item)}
          isLoading={isLoading}
        />
      </TableContainer>
    </div>
  );
};

export default IncidentsByTrends;
